export const membershipReferralsTableHeaderMessages = {
  signUpDate: 'Sign Up Date',
  receiver: 'Member',
  senderAwardGrantedDate: 'Sender Award Granted',
  receiverAwardGrantedDate: 'Receiver Award Granted',
};

export const membershipReferralsTableMessages = {
  tableHeaderTabLabel: 'Members Referred',
};
